import { render } from "./user-invoice.vue?vue&type=template&id=8f1602d0"
import script from "./user-invoice.vue?vue&type=script&lang=js"
export * from "./user-invoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__